import { styled } from "@mui/material";
import { CertaintyBarPropsI } from ".";

export const BarItem = styled('div')<CertaintyBarPropsI>(({ theme, colors }) => ({
  width: 20,
  height: 6,
  backgroundColor: colors ?? theme.palette.grey,
  borderRadius: 4
}))